/**
 * StandardPagination - Componente di paginazione standardizzato
 * Gestisce la paginazione con stili consistenti e effetti hover
 */

import React from 'react';
import { TablePagination, TablePaginationProps } from '@mui/material';
import FixedPagination from './FixedPagination';

interface StandardPaginationProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rowsPerPageOptions?: number[];
  showFirstButton?: boolean;
  showLastButton?: boolean;
  component?: React.ElementType;
}

const StandardPagination: React.FC<StandardPaginationProps> = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [5, 10, 25, 50],
  showFirstButton = true,
  showLastButton = true,
  component = 'div',
  ...props
}) => {
  return (
    <FixedPagination>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component={component}
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        showFirstButton={showFirstButton}
        showLastButton={showLastButton}
        sx={{
          '& .MuiTablePagination-select': {
            '& .MuiSelect-select': {
              '&:hover': {
                backgroundColor: 'primary.main',
                color: 'white',
                borderRadius: '4px',
              }
            }
          },
          '& .MuiTablePagination-menuItem': {
            '&:hover': {
              backgroundColor: 'primary.main',
              color: 'white',
            },
            '&.Mui-selected': {
              backgroundColor: 'primary.main',
              color: 'white',
              '&:hover': {
                backgroundColor: 'primary.dark',
              }
            }
          }
        }}
        {...props}
      />
    </FixedPagination>
  );
};

export default StandardPagination;
